import { useProvidersQuery } from 'hooks/api/provider';
import { IProvider } from 'constants/types';

function normalizeProvidersResults(data: unknown): IProvider[] {
  if (Array.isArray(data)) {
    return data;
  }

  if (
    data &&
    typeof data === 'object' &&
    Array.isArray((data as { results?: unknown }).results)
  ) {
    return (data as { results: IProvider[] }).results;
  }

  return [];
}

export const useProviders = () => {
  const { data, isFetching } = useProvidersQuery();

  return {
    count:
      data && typeof data === 'object' && 'count' in data
        ? (data as { count?: string | number }).count
        : undefined,
    results: normalizeProvidersResults(data),
    isFetching,
  };
};
